import {Component, OnInit} from '@angular/core';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {MatToolbar} from "@angular/material/toolbar";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    MatToolbar
  ],
  standalone: true
})
export class HeaderComponent implements OnInit {

  title: string | undefined;

  constructor(private translateService: TranslateService) {
  }

  ngOnInit() {
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.translateService.get('app.title').subscribe((translation: string) => {
        this.title = translation;
      });
    });
  }
}
